import React from "react";
import { getInitials } from "../../../utils/helper";
import { PAID, PENDING, PLAN_STATUS_MAP } from "../../../utils/constants";

interface PatientHeaderProps {
  name: string;
  status: string;
}

const PatientHeader: React.FC<PatientHeaderProps> = ({ name, status }) => {
  const title = name ? getInitials(name) : "";
  const mappedStatus = PLAN_STATUS_MAP[status as keyof typeof PLAN_STATUS_MAP];

  return (
    <header className="flex overflow-hidden flex-col justify-center p-4 w-full bg-white rounded-3xl shadow-[0px_1px_16px_rgba(0,0,0,0.05)]">
      <div className="flex gap-4 justify-center items-center w-full">
        <div className="flex flex-1 shrink gap-2 items-center self-stretch my-auto font-semibold basis-6 ">
          <div className="overflow-hidden self-stretch py-1 my-auto w-10 h-10 text-base tracking-normal leading-8 text-purple-500 whitespace-nowrap bg-violet-50 rounded-full flex items-center justify-center">
            {title}
          </div>
          <div className="self-stretch my-auto text-base text-gray-800 w-[100px] text-left break-words">
            {name}
          </div>
        </div>
        {mappedStatus && (
          <div
            className={`overflow-hidden gap-2 self-stretch px-3 py-1 my-auto text-xs font-medium ${
              status === PENDING
                ? "text-orange-400 bg-orange-100"
                : status === PAID
                ? "text-[#1F8B24] bg-[#C5F2C7]"
                : "text-[#DA100B] bg-[#FCD0CF]"
            } rounded-3xl`}
          >
            {mappedStatus}
          </div>
        )}
      </div>
    </header>
  );
};

export default PatientHeader;
